module.exports = __webpack_public_path__ + "static/img/logo.2395f42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.jpg
// module id = 4GjL
// module chunks = 0